/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentsUpdateAgent } from "../../funcs/agentsUpdateAgent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateAgentRequest$inboundSchema,
};

export const tool$agentsUpdateAgent: ToolDefinition<typeof args> = {
  name: "agents-update-agent",
  description: `Update an agent`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentsUpdateAgent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
